module.exports = __webpack_public_path__ + "img/nav_bg_1.5adc689.png";